import { Flex, Text } from "@chakra-ui/react"
import { useErrorBoundary } from "react-error-boundary"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "src/recoil/atoms/room"
import TryAgainBtn from "../tryAgainBtn"

function ComponentFallback() {
  const { resetBoundary } = useErrorBoundary()
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <Flex
      w="100%"
      h="100%"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      gap="1rem"
      role="alert"
    >
      <Text fontWeight="bold" color={roomStyles.alertTextColor}>
        Something went wrong
      </Text>
      <TryAgainBtn onClick={resetBoundary}>Try again</TryAgainBtn>
    </Flex>
  )
}

export default ComponentFallback
